import axios from 'axios'
import { baseURL } from '../helpers/constants'

export default class UserService {
    async authorize(email, password) {
        try {
            const response = await axios.post(
                baseURL + 'authorization',
                {
                    email: email,
                    password: password
                }
            );
            return response;
        } catch (error) {
            console.error('Authorization error:', error);
            throw error;
        }
    }
}
